import axios, { AxiosResponse } from "axios";
import { GetJourneryData, GetTimeTableResponse } from "../typeDef/journery.model";

export async function getTrainTimeTableData(params: GetJourneryData): Promise<AxiosResponse<GetTimeTableResponse>> {
    return await axios.post<GetJourneryData, AxiosResponse<GetTimeTableResponse>>
        (`${process.env.REACT_APP_API_BASE_URL}/point-to-point/get-train-timetable-data`,  params );
}